import { ReactElement, useState } from 'react';
import { useNavigate } from "react-router-dom";

import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import { Divider, SxProps, Theme } from '@mui/material';
import { useEnvironmentContext } from '../Contexts/EnvironmentProvider';
import { useGetAltSite, useNavigateAltSite } from '../Hooks/useNavigateAltSite';
import { useAuthContext } from '../Contexts/AuthProvider';
import { useMsal } from '@azure/msal-react';
import NavigateHome from '../NavigateHome';

interface Props {
  iconElement: ReactElement;
  sx?: SxProps;
  mobile: boolean;

  position?: 'left' | 'right';
  items: { path: string, label: string }[];
}

const NavMenu = ({ iconElement, mobile, position, items, sx }: Props) => {
  const { instance: msalInstance } = useMsal();
  const { user, isSchoolUser, signOut } = useAuthContext();

  const navigate = useNavigate();
  const getAltSite = useGetAltSite();

  const { siteVariant, pageVariant } = useEnvironmentContext();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const getNavigationHandler = (url: string) => {
    return () => {
      handleClose();
      navigate(url);
    }
  }

  const handleNavigateAlt = () => {
    handleClose();

    window.location.href = getAltSite();
//    window?.open(getAltSite(), '_blank')?.focus()
  }

  const handleSignOut = async () => {
    handleClose();

    if (msalInstance.getActiveAccount()) {
      navigate('/auth/ms/logout');
    } else {
      await signOut();
      NavigateHome();
    }
  }

  const getMenuItems = () => {
    let ret = [];

    if (pageVariant === 'main') {
      if (user) {
        ret.push(
          <MenuItem key='menu-alt' onClick={handleNavigateAlt} sx={menuItemStyle}>Your Channel</MenuItem>,
        );

        if (isSchoolUser()) {
          ret.push(
            <MenuItem key='portfolio' onClick={getNavigationHandler(`/portfolio/${user.id}`)} sx={menuItemStyle}>Portfolio</MenuItem>,
          )
        }

//        ret.push(<Divider key='div-alt' />);
      }

      ret.push(
        ...(items.map(x => (
          <MenuItem key={x.path} onClick={getNavigationHandler(x.path)} sx={menuItemStyle}>{x.label}</MenuItem>
        )))
      )

//      if (items.length > 0) ret.push(<Divider />);

//      ret.push(<MenuItem key={'guide'} onClick={getNavigationHandler('/guide')} sx={menuItemStyle}>User Guide</MenuItem>);

 //     ret.push(<Divider />);

      /*
      if(!isSchoolUser()) {
        ret.push(
          <MenuItem onClick={getNavigationHandler('/membership')} sx={menuItemStyle}>Membership</MenuItem>,
          <Divider />
        );
      }
      */

      ret.push(
        <MenuItem key={'contact'} onClick={getNavigationHandler('/contact')} sx={menuItemStyle}>Contact Us</MenuItem>,
      );


      if (user) {
        ret.push(
          <MenuItem key='menu-signout' onClick={handleSignOut} sx={menuItemStyle}>Log Out</MenuItem>
        )
      }
    }

    else {
      ret.push(
        <MenuItem key={'/history'} onClick={getNavigationHandler('/history')} sx={menuItemStyle}>History</MenuItem>,
        <MenuItem key='menu-alt' onClick={handleNavigateAlt} sx={menuItemStyle}>Vactors web app</MenuItem>,
        <MenuItem key={'home'} onClick={() => window?.open('https://www.vactors.club', '_blank')?.focus()} sx={menuItemStyle}>Home Page</MenuItem>
      )

      if (user) {
        ret.push(
//          <Divider key='div-signout' />,
          <MenuItem key='menu-signout' onClick={handleSignOut} sx={menuItemStyle}>Log Out</MenuItem>
        )
      }
    }

    return ret;
  }
  const menuItemStyle: SxProps<Theme> = mobile ?
    {}
    :
    { pl: '20px', pr: '50px', py: '10px', fontSize: '11pt' };

  return (
    <>
      <IconButton onClick={handleClick} sx={sx}>
        {iconElement}
      </IconButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: position ?? (mobile ? 'left' : 'right'),
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: position ?? (mobile ? 'left' : 'right'),
        }}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        PaperProps={{
          sx: { marginTop: '5px', width: (mobile ? '100%' : 'auto') }
        }}
      >
        {getMenuItems()}
      </Menu>
    </>
  );
}

export default NavMenu;